import { MenuCategory } from "@/hooks/useMenu";
import { ArrowUpRight } from "lucide-react";
import { useState } from "react";
import { Drawer } from "./ui/custom/Drawer";
import { CategoryDrawer } from "./CategoryDrawer";
import { cn } from "@/lib/utils";

function CategoriesGrid({ categories }: { categories: MenuCategory[] }) {
  const [openCategory, setOpenCategory] = useState<MenuCategory>();

  function handleCloseCategory() {
    setOpenCategory(undefined);
  }

  return (
    <>
      <Drawer
        isOpen={openCategory !== undefined}
        closeDrawer={handleCloseCategory}
        classes={{
          root: "!z-[19]",
          paper: "rounded-t-2xl !overflow-visible !bg-transparent",
        }}
      >
        <CategoryDrawer
          category={openCategory}
          handleClose={handleCloseCategory}
        />
      </Drawer>
      <div className="p-4 flex flex-col gap-y-4 bg-muted">
        <h2 className="text-xl tracking-tighter font-medium">
          Browse categories
        </h2>
        <div className="grid grid-cols-2 gap-4 min-h-[40vh] md:grid-cols-4">
          {categories.map((category) => {
            const hasAvailableProducts =
              category.products.find(
                (product) => product.unavailable !== true && product.can_purchase !== false
              ) !== undefined;
            return (
              <button
                type="button"
                onClick={() => setOpenCategory(category)}
                disabled={!hasAvailableProducts}
                key={category.id}
                className={cn(
                  "group",
                  hasAvailableProducts ? "opacity-100" : "opacity-50"
                )}
              >
                <GridItem
                  category={category}
                  hasAvailableProducts={hasAvailableProducts}
                />
              </button>
            );
          })}
        </div>
      </div>
    </>
  );
}

function GridItem({
  category,
  hasAvailableProducts,
}: {
  category: MenuCategory;
  hasAvailableProducts: boolean;
}) {
  return (
    <article className="overflow-hidden relative rounded-md p-3 bg-background group-hover:shadow-md transition border flex justify-start text-start items-start aspect-[5/4] w-full h-full disabled:pointer-events-none disabled:opacity-50">
      <div className="flex flex-row items-center gap-y-2">
        <h2 className="font-medium tracking-tight text-lg">{category.name}</h2>
      </div>

      <div className="absolute right-2 bottom-2 rounded-lg bg-primary text-primary-foreground p-2 flex items-center gap-1 justify-center">
        {hasAvailableProducts ? (
          <ArrowUpRight
            size={16}
            className="group-hover:rotate-45 rotate-0 transition"
          />
        ) : (
          <span className="text-[10px]">Unavailable</span>
        )}
      </div>
    </article>
  );
}

export { CategoriesGrid };
